import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=07c09b50&scoped=true&"
import script from "./MyHistory.vue?vue&type=script&lang=js&"
export * from "./MyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c09b50",
  null
  
)

export default component.exports